/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockManageListResVo
 */
export interface AdminStockManageListResVo {
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminStockManageListResVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminStockManageListResVo
     */
    userName?: string;
    /**
     * 库存SKU数
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    skuCount?: number;
    /**
     * 库存总数量
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    totalItemQty?: number;
    /**
     * 仓储计费体积(CBM)
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    totalCbm?: number;
    /**
     * 保管费欠费金额(韩币)
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    unpaidStorageFeeKrw?: number;
    /**
     * 今日预计保管费(韩币)
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    todayStorageFeeKrw?: number;
    /**
     * 预存款余额(韩币)
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    walletBalanceKrw?: number;
    /**
     * 余额状态：1正常，2不足
     * @type {number}
     * @memberof AdminStockManageListResVo
     */
    balanceStatus?: number;
    /**
     * 余额状态名称，按当前语言返回
     * @type {string}
     * @memberof AdminStockManageListResVo
     */
    balanceStatusName?: string;
}

/**
 * Check if a given object implements the AdminStockManageListResVo interface.
 */
export function instanceOfAdminStockManageListResVo(value: object): value is AdminStockManageListResVo {
    return true;
}

export function AdminStockManageListResVoFromJSON(json: any): AdminStockManageListResVo {
    return AdminStockManageListResVoFromJSONTyped(json, false);
}

export function AdminStockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'totalItemQty': json['totalItemQty'] == null ? undefined : json['totalItemQty'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'unpaidStorageFeeKrw': json['unpaidStorageFeeKrw'] == null ? undefined : json['unpaidStorageFeeKrw'],
        'todayStorageFeeKrw': json['todayStorageFeeKrw'] == null ? undefined : json['todayStorageFeeKrw'],
        'walletBalanceKrw': json['walletBalanceKrw'] == null ? undefined : json['walletBalanceKrw'],
        'balanceStatus': json['balanceStatus'] == null ? undefined : json['balanceStatus'],
        'balanceStatusName': json['balanceStatusName'] == null ? undefined : json['balanceStatusName'],
    };
}

export function AdminStockManageListResVoToJSON(json: any): AdminStockManageListResVo {
    return AdminStockManageListResVoToJSONTyped(json, false);
}

export function AdminStockManageListResVoToJSONTyped(value?: AdminStockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'skuCount': value['skuCount'],
        'totalItemQty': value['totalItemQty'],
        'totalCbm': value['totalCbm'],
        'unpaidStorageFeeKrw': value['unpaidStorageFeeKrw'],
        'todayStorageFeeKrw': value['todayStorageFeeKrw'],
        'walletBalanceKrw': value['walletBalanceKrw'],
        'balanceStatus': value['balanceStatus'],
        'balanceStatusName': value['balanceStatusName'],
    };
}

